module.exports = "<div class=\"page-layout simple fullwidth mat-white-bg\" fusePerfectScrollbar>\n    <app-basic-page></app-basic-page>\n</div>\n"